import { graphql, useStaticQuery } from 'gatsby';

// This will grab all of the fields in "Settings".
const GetSettings = (location) => {
  
    // Grab the initial data
    const { settings } = useStaticQuery(graphql`
        {
            settings: allStoryblokEntry(filter: {field_component: {eq: "settings"}}) {
                edges {
                    node {
                    name
                    full_slug
                    content
                    }
                }
            }
        }
    `)
    let { pathname } = location
    let language = pathname.split("/")[1].replace('/', '')

    if( language === "editor" ) {
        const urlParams = new URLSearchParams(window.location.search)
        language = urlParams.get('path').split("/")[0].replace('/', '')
    }    

    let activeLanguage = ['es', 'en', 'nz', 'za', 'au', 'demo'].includes(language) ? language : 'en'
    let correctSetting = settings.edges.filter(edge => edge.node.full_slug.indexOf(activeLanguage) > -1)
    let hasSetting = correctSetting && correctSetting.length ? correctSetting[0].node : {}
    let content = typeof hasSetting.content === 'string' ? JSON.parse(hasSetting.content) : hasSetting.content
    return Object.assign({}, content, {content: content})
}

export default GetSettings